import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { Link } from "react-router-dom";
import { decodeJwt } from "../utiles/cookie";

import 'simplebar/dist/simplebar.min.css'

import {MENU_SELECTMENU, SETTING_LOADING, SIDENAVBAR_ONOFF, COMMON_BPLC_VISIBLE} from "../modules/action/actionTypes";

import axios from "axios";
import $ from "jquery";

const AppSidebar = () => {

  const dispatch = useDispatch();
  const [sideNavBarToggle, setSideNavBarToggle] = useState(false);
  const [upMenuDashBoard, setUpMenuDashBoard] = useState(true);
  const [upMenuSetting, setUpMenuSetting] = useState(true);
  const [upMenuMore, setUpMenuMore] = useState(true);
  const [upMenuAdminInvoice, setUpMenuAdminInvoice] = useState(true);
  const [upMenuAdminBoard, setUpMenuAdminBoard] = useState(true);
  const [upMenuAdminSetting, setUpMenuAdminSetting] = useState(true);
  const [menuList, setMenuList] = useState([]);
  const memberInfo = decodeJwt('codipai');
  const selectMenu = useSelector(state => state.menu);
  const selectMenuSelector = useSelector(state => state);

  var selectedUpMenuId = ''
  let isClosed;
  let group = [];
  let result = [];
  let list = [];
  const _nav1 = [];

  function Menu(name, to, sortNo, upMenuId) {
    //this.component= CNavItem;
    this.name = name;
    this.to = to;
    this.badge = {
      color: 'info',
    };
    this.sortNo = sortNo;
    this.upMenuId = upMenuId;
  }

  useEffect(() => {
    api();
  }, [memberInfo?.loginId])

  
  async function api() {
    //dispatch({type: SETTING_LOADING, Setting_Loading: true})
    if (memberInfo != undefined) {
      axios.get("/api/menus/" + memberInfo.loginId + "/menus")
      .then(res => {
        list = res.data.resultData
        for (let i = 0; i < list.length; i++) {
          const menu1 = new Menu();
          menu1.menuNm = list[i].menuNm;
          menu1.url = list[i].url;
          menu1.upMenuId = list[i].upMenuId;
          menu1.sortNo = list[i].sortNo;
          menu1.depthNo = list[i].depthNo;
          menu1.groupEngNm = list[i].groupEngNm;
          
          _nav1.push(menu1);

          //상단 사업장선택 숨김처리 (더보기, 관리자)
          //첫진입, 새로고침시 1회용 판단
          if ("/" + location.pathname.split('/')[1] == list[i].url) {
            if (list[i].upMenuId == "3000" || list[i].upMenuId == "7000" || list[i].upMenuId == "8000" || list[i].upMenuId == "9000") {
              dispatch({ type: COMMON_BPLC_VISIBLE, Common_Bplc_Visible: false})
            }
            else {
              dispatch({ type: COMMON_BPLC_VISIBLE, Common_Bplc_Visible: true})
            }
            
          }
        }
        setMenuList(_nav1);

        //dispatch({type: SETTING_LOADING, Setting_Loading: false})
      })
    }
  }

  useEffect(() => {
    dispatch({ type: SIDENAVBAR_ONOFF, sideNavBarOnOff: sideNavBarToggle });
  }, [sideNavBarToggle])

  const toggleClass = () => {
    const currentState = sideNavBarToggle;
    setSideNavBarToggle(!currentState);
  }

  const toggleGroup = (menuNm) => {
    switch(menuNm) {
      case "대시보드" : setUpMenuDashBoard(!upMenuDashBoard); break;
      case "분석환경설정" : setUpMenuSetting(!upMenuSetting); break;
      case "더보기" : setUpMenuMore(!upMenuMore); break;
      case "청구/수납" : setUpMenuAdminInvoice(!upMenuAdminInvoice); break;
      case "게시판 관리" : setUpMenuAdminBoard(!upMenuAdminBoard); break;
      case "고객 관리" : setUpMenuAdminSetting(!upMenuAdminSetting); break;
    }
  }

  useEffect(() => {
    if (menuList.length > 0) {
      setUpMenuDashBoard(true);
      setUpMenuSetting(true);
      setUpMenuMore(true);
      setUpMenuAdminInvoice(true);
      setUpMenuAdminBoard(true);
      setUpMenuAdminSetting(true);

      for (var i = 0; i < menuList.length; i++) {
        if ("/" + location.pathname.split('/')[1] == menuList[i].url) {
          selectedUpMenuId = menuList[i].upMenuId
          break;
        }
      }

      for (var i = 0; i < menuList.length; i++) {
        if (menuList[i].depthNo == "1") {
          if (selectedUpMenuId == menuList[i].upMenuId) {
            switch(menuList[i].upMenuId) {
              case "1000" : setUpMenuDashBoard(false); break;
              case "2000" : setUpMenuSetting(false); break;
              case "3000" : setUpMenuMore(false); break;
              case "7000" : setUpMenuAdminInvoice(false); break;
              case "8000" : setUpMenuAdminBoard(false); break;
              case "9000" : setUpMenuAdminSetting(false); break;
            }
            menuList[i].selected = "selected"
            menuList[i].isClosed = false
          }
          else {
            menuList[i].selected = ""
            menuList[i].isClosed = true
          }
        }
      }
      setMenuList(menuList);
    }
  }, [selectMenu, menuList])

  const funcMenuClick= (menuItem) => {
    setUpMenuDashBoard(true);
    setUpMenuSetting(true);
    setUpMenuMore(true);
    setUpMenuAdminInvoice(true);
    setUpMenuAdminBoard(true);
    setUpMenuAdminSetting(true);
    dispatch({ type: MENU_SELECTMENU, menu_selectMenu: menuItem})

    //상단 사업장선택 숨김처리 (더보기, 관리자)
    if (menuItem.upMenuId == "3000" || menuItem.upMenuId == "7000" || menuItem.upMenuId == "8000" || menuItem.upMenuId == "9000") {
      dispatch({ type: COMMON_BPLC_VISIBLE, Common_Bplc_Visible: false})
    }
    else {
      dispatch({ type: COMMON_BPLC_VISIBLE, Common_Bplc_Visible: true})
    }
  }

  return (
    <div className={sideNavBarToggle ? 'vertical_collpsed' : ''}>
      <div className="vertical_menu">
        <div className="wrapper">
          <div className="mask">
            <div className="offset">
              <div className="sidebar_content_wrapper">
                <div className="sidebar_content">
                  <div className="sidebar_menu">
                    <ul className="metismenu">
                      <li className="btn_collpsed">
                        {/*메뉴 접고펴기 버튼*/}
                        <button type="button" title="메뉴접기" name="sideToggle" className="header_item" onClick={toggleClass}>
                          <i className="btn_header"></i>
                        </button>
                      </li>
                      {/* {menuList &&
                        menuList.map((item, index) => (
                          // url이동을 할 경우 location.pathname을 이용하여 selected 클래스를 추가한다.
                          // <li className={(item.url === location.pathname) ? 'menu selected' : 'menu'} key={index} onClick={() => { selectMenuFunc(item.menuNm) }}>
                          <li className={(item.url === '/'+location.pathname.split('/')[1]) ? 'menu selected' : 'menu'} key={index} onClick={() => { dispatch({ type: MENU_SELECTMENU, menu_selectMenu: item.menuNm })}}>
                            <Link to={menuList[index].url} className={menuList[index].classNm}>
                              <i></i><span className="menu_name">{menuList[index].menuNm}</span>
                            </Link>
                          </li>
                        ))} */}
                      {
                        menuList &&
                          menuList.map((outerItem, index) => {
                            if (outerItem.depthNo == "1") {
                              switch(outerItem.sortNo) {
                                case "1000" : isClosed = upMenuDashBoard; break;
                                case "2000" : isClosed = upMenuSetting; break;
                                case "3000" : isClosed = upMenuMore; break;
                                case "7000" : isClosed = upMenuAdminInvoice; break;
                                case "8000" : isClosed = upMenuAdminBoard; break;
                                case "9000" : isClosed = upMenuAdminSetting; break;
                              }
                              group.push(
                                <ul className={isClosed == true? "closed":"open"}  key={index}>
                                  <li className={"header " + outerItem.selected} onClick={()=>{toggleGroup(outerItem.menuNm)}}>
                                    <a className={outerItem.groupEngNm}><i></i><span className="menu">{outerItem.menuNm}</span></a>                                    
                                    {/* <i></i><a><span className="menu">{outerItem.menuNm}</span></a> */}
                                  </li>
                                  {
                                    menuList.map((innerItem, index) => {
                                      if (innerItem.depthNo != "1" && outerItem.upMenuId == innerItem.upMenuId) {
                                        return (
                                          <li className={(innerItem.url === '/'+location.pathname.split('/')[1]) ? 'menu selected' : 'menu'} key={index} onClick={() => funcMenuClick(innerItem)}>
                                            <Link to={innerItem.url} >
                                              <span className="menu">{innerItem.menuNm}</span>                                              
                                              {/* <i></i><span className="menu">{innerItem.menuNm}</span> */}
                                            </Link>
                                          </li>
                                        )
                                      }
                                    })
                                  }
                                </ul>
                              )

                              result = group
                              group = []
                              return (
                                  result[0]
                              )
                            }
                          })
                        // menuList &&
                        //   menuList.map((outerItem, index) => {
                        //     if (outerItem.depthNo == "1") {
                        //       var headerSelected = ''
                        //       switch(outerItem.sortNo) {
                        //         case "100" : isClosed = upMenuDashBoard; groupEngNm="dashboard"; 
                        //           if (location.pathname.split('/')[1] == 'realtime') {
                        //             headerSelected = 'selected';
                        //           }
                        //           break;
                        //         case "200" : isClosed = upMenuSetting; groupEngNm="setting"; 
                        //           if (location.pathname.split('/')[1] == '3dsetting') {
                        //             headerSelected = 'selected';
                        //           }
                        //           break;
                        //         case "300" : isClosed = upMenuMore; groupEngNm="more"; 
                        //           if (location.pathname.split('/')[1] == 'myInfoPage' || location.pathname.split('/')[1] == 'managerPage'
                        //             || location.pathname.split('/')[1] == 'managerMemberPage' || location.pathname.split('/')[1] == 'board'
                        //             || location.pathname.split('/')[1] == 'alarm' || location.pathname.split('/')[1] == 'notice') {
                        //             headerSelected = 'selected';
                        //           }
                        //           break;
                        //         case "900" : isClosed = upMenuAdmin; groupEngNm="admin"; 
                        //           if (location.pathname.split('/')[1] == 'adminQuestion' || location.pathname.split('/')[1] == 'adminFAQ'
                        //           || location.pathname.split('/')[1] == 'adminNotice' || location.pathname.split('/')[1] == 'managerMemberPage'
                        //           || location.pathname.split('/')[1] == 'accountManager' || location.pathname.split('/')[1] == 'adminCameraManagementPage'
                        //           || location.pathname.split('/')[1] == 'monitoring') {
                        //             headerSelected = 'selected';
                        //           }
                        //           break;
                        //       }

                        //       groupHeader.push(
                        //         <ul className={isClosed == true? "closed":"open"}  key={index}>
                        //           <li className={"header " + headerSelected} onClick={()=>{toggleGroup(outerItem.menuNm)}}>
                        //             <a className={groupEngNm}><i></i><span className="menu">{outerItem.menuNm}</span></a>                                    
                        //             {/* <i></i><a><span className="menu">{outerItem.menuNm}</span></a> */}
                        //           </li>
                        //           {
                        //             menuList.map((innerItem, index) => {
                        //               if (innerItem.depthNo != "1" && outerItem.upMenuId == innerItem.upMenuId) {
                        //                 return (
                        //                   <li className={(innerItem.url === '/'+location.pathname.split('/')[1]) ? 'menu selected' : 'menu'} key={index} onClick={() => { dispatch({ type: MENU_SELECTMENU, menu_selectMenu: innerItem.menuNm })}}>
                        //                     <Link to={innerItem.url} >
                        //                       <span className="menu">{innerItem.menuNm}</span>                                              
                        //                       {/* <i></i><span className="menu">{innerItem.menuNm}</span> */}
                        //                     </Link>
                        //                   </li>
                        //                 )
                        //               }
                        //             })
                        //           }
                        //         </ul>
                        //       )

                        //       result = groupHeader
                        //       groupBody = []
                        //       groupHeader = []
                        //       return (
                        //           result[0]
                        //       )
                        //     }
                        // })
                      }
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

}

export default React.memo(AppSidebar)
